'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _wrapHttpClient = require('./wrapHttpClient');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _wrapHttpClient.wrapHttpClient)(_noAuthApiClient2.default);
module.exports = exports['default'];